var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRehab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2a7bfe",
    height: "80px",
    width: "80px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 458.52 458.52",
    xmlSpace: "preserve",
    stroke: "#2a7bfe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.776,271.586c-23.856,0-44.034,0-44.034,0l15.004,52.377l-29.822,85.226c-3.861,11.037,1.955,23.114,12.991,26.976 c11.039,3.862,23.115-1.958,26.976-12.991l32.044-91.579c1.446-4.134,1.575-8.613,0.369-12.823L218.776,271.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.806,271.587c-13.159,0-30.84,0-47.678,0l24.555,48.141l-3.183,95.756c-0.388,11.686,8.771,21.474,20.456,21.863 c0.24,0.008,0.478,0.012,0.716,0.012c11.367,0,20.767-9.022,21.147-20.468l3.364-101.215c0.119-3.581-0.672-7.131-2.3-10.323 L274.806,271.587z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.237,
    cy: 57.342,
    r: 36.182
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.908,255.398h138.153l-30.254-14.663c-2.761-1.338-5.29-3.015-7.559-4.96H98.908 c-40.652,0-73.726,33.073-73.726,73.726v108.234c-8.062,0-7.411,0-15.371,0c-5.418,0-9.811,4.393-9.811,9.811 c0,5.418,4.393,9.811,9.811,9.811h50.365c5.418,0,9.811-4.393,9.811-9.811c0-5.418-4.393-9.811-9.811-9.811 c-8.033,0-7.41,0-15.371,0V309.503C44.806,279.669,69.076,255.398,98.908,255.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.384,224.227l-55.79-27.04l-9.188-67.544l22.601,54.924l17.778,8.617l8.657-56.926 c1.798-11.821-6.328-22.86-18.148-24.658l-48.615-7.393c-11.82-1.798-22.86,6.328-24.658,18.148l-14.786,97.232h16.372 c-1.452-4.668-1.558-7.661-1.364-9.687l6.982-72.945l10.146,74.585c0.81,5.948,4.541,11.095,9.942,13.713 c39.757,19.269,16.838,8.16,64.437,31.231c8.135,3.944,18.166,1.211,23.052-6.706 C307.417,240.672,303.883,228.833,294.384,224.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.708,417.737c-8.762,0-7.206,0-15.816,0V309.503c0-40.653-33.073-73.726-73.726-73.726h-37.788 c0.864,6.491-0.07,13.288-3.074,19.623h40.862c29.833,0,54.104,24.271,54.104,54.104v108.234c-9.356,0-11.435,0-11.82,0 c-0.055,0-0.078,0-0.08,0c-0.213,0-0.926,0-3.026,0c-5.418,0-9.811,4.393-9.811,9.811c0,5.418,4.393,9.811,9.811,9.811h50.365 c5.418,0,9.811-4.393,9.811-9.811C458.52,422.13,454.126,417.737,448.708,417.737z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehab);
export default __webpack_public_path__ + "static/media/rehab.4145ba4a4e7ac60ebe1741346506d322.svg";
export { ForwardRef as ReactComponent };